declare const APP_VERSION: string | undefined;

export const environment = {
  production: false,
  version: typeof APP_VERSION !== 'undefined' ? APP_VERSION : '2.3.0',
  rootUrl: 'dev.watchtower.xsoc.de',
  branding: {
    brandName: 'XSOC WatchTower One',
    productNameArticleDeCapitalized: 'Der',
    productName: 'XSOC WatchTower One',
    companyName: 'XNETSOLUTIONS Cyper Security Systems GmbH',
    supportEmail: 'support@xsoc.de',
    operationsEmail: "'operations@xsoc.de'",
    websiteUrl: 'xnetsolutions.de',
    featureRequestEmailAddress: 'operations@xsoc.de',
  },
};
